// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingspinner_container__1OAWX","containerBg":"loadingspinner_containerBg__2U8Og","box":"loadingspinner_box__UeYIn","spinner":"loadingspinner_spinner__AWyqr"};